import { appendQueryParams } from '@packages/shared/core/common/utils/url/appendQueryParams';
import { useServices } from '@packages/shared/core/common/hooks/useServices';
import { normalizeError } from '@packages/shared/core/common/utils/errors';
import { checkIsClientSide } from '@packages/shared/core/common/utils/checkIsClientSide';

export const useRedirectWithDeviceId = () => {
  const { analyticsService, logger } = useServices();

  const redirectWithDeviceId = async (url: string) => {
    if (!checkIsClientSide()) return;

    try {
      const deviceId = await analyticsService.getDeviceId();

      const URLToRedirect = new URL(url);
      const paramsObj = {
        amp_device_id: deviceId,
      };

      const URLToRedirectWithParams = appendQueryParams(URLToRedirect, paramsObj);
      window.location.assign(URLToRedirectWithParams.href);
    } catch (e) {
      const error = normalizeError(e);
      logger.error(error);
    }
  };

  return { redirectWithDeviceId };
};
